import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { NgxSpinnerService } from "ngx-spinner";
import { ProductService } from "src/app/components/shared/services/product.service";
import { constApi } from "src/environments/constApi";
import { ProductSelectDialogComponent } from "../product-select-dialog/product-select-dialog.component";

@Component({
  selector: "app-proformas-ecc",
  templateUrl: "./proformas-ecc.component.html",
  styleUrls: ["./proformas-ecc.component.sass"],
})
export class ProformasEccComponent implements OnInit {
  constructor(
    private productService: ProductService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) {}
  imagenes: any[] = [
    { ImagenP: "https://novaplaza.pe/assets/img/nodisponible.png", NombreItm:"Procesadores", PV3:0, DenoCat: "Procesadores" },
    { ImagenP: "https://novaplaza.pe/assets/img/nodisponible.png", NombreItm:"Ram", PV3:0, DenoCat: "Ram" },
    { ImagenP: "https://novaplaza.pe/assets/img/nodisponible.png", NombreItm:"Disco Duro", PV3:0, DenoCat: "Disco Duro" },
    { ImagenP: "https://novaplaza.pe/assets/img/nodisponible.png", NombreItm:"Monitor", PV3:0, DenoCat: "Monitor" },
    { ImagenP: "https://novaplaza.pe/assets/img/nodisponible.png", NombreItm:"Tarjeta de Video", PV3:0, DenoCat: "Tarjeta de Video" },
    { ImagenP: "https://novaplaza.pe/assets/img/nodisponible.png", NombreItm:"Placa Madre", PV3:0, DenoCat: "Placa Madre" },
  ];
  procesadoresArr: any[] = [];
  totalItems: number = 0;
  async ngOnInit(): Promise<void> {}
  async obtenerProductos(param) {
    return await this.productService
      .getParam(constApi.ITEMSEC_LIST, param)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  dialogProductSelect(i:any) {
    let digalogRef = this.dialog.open(ProductSelectDialogComponent, {
      data: i,
      panelClass: "product-dialog",
      autoFocus: false,
      width:"500px",
      position: {
        top: '5'
      }
    });
    digalogRef.beforeClosed().subscribe((result: any) => {
    this.totalItems = 0;
    if(result != undefined)
        switch (result.Codigo) {
          case "AAC22":
            this.imagenes[0] = result;
            break;
          case "AAC05":
            this.imagenes[1] = result;
            break;
          case "AAC06":
            this.imagenes[2] = result;
            break;
          case "AEQ16":
            this.imagenes[3] = result;
            break;
        }
      this.imagenes.forEach(x => {
        this.totalItems += x.PV3;
      })
    });
  }
}
